import { getUserData } from 'approot/shared/api/auth/auth';
import { getStudentUserData } from 'approot/shared/api/auth/student-user-auth';
import { getStudentData } from 'approot/student-class-to-do/student-class-to-do.utils';

export function getSessionToken() {
  // if the user is a teacher, get the token from the user data

  const userData = getUserData();
  if (userData?.token) {
    return userData.token;
  }

  // if the user is a student, get the token from the student data
  const studentUserData = getStudentUserData();
  if (studentUserData?.token) {
    return studentUserData.token;
  }

  // if the user is a student, get the token from the student data
  const unidentifiedStudentData = getStudentData();
  if (unidentifiedStudentData.token) {
    return unidentifiedStudentData.token;
  }

  return undefined;
}
